// extracted by css-extract-rspack-plugin
export default {"overlaySelect":"overlaySelect-t5UqqJ","operatorSelect":"operatorSelect-x8babW","labelRow":"labelRow-aMRRMY","labelText":"labelText-UhkfA0","labelPostfix":"labelPostfix-jpNJSo"};